import { memo } from 'react'
import type { BloomSectionModelProps } from '@/components/home/components/bloom-section/bloom-section.model'
import { useBloomSectionModel } from '@/components/home/components/bloom-section/bloom-section.model'
import { BloomSectionView } from '@/components/home/components/bloom-section/bloom-section.view'

export const BloomSectionViewModel = memo(function BloomSectionViewModel(
  props: BloomSectionModelProps,
) {
  const model = useBloomSectionModel(props)
  return <BloomSectionView {...model} />
})
